import React from 'react';
import { Spin } from 'antd';

const RouteFallback = () => (
  <div
    className="flex items-center justify-center min-h-[280px] w-full"
    style={{ fontFamily: 'CustomFont' }}
  >
    <Spin size="large" tip="در حال بارگذاری..." />
  </div>
);

export default RouteFallback;
